import React from "react";
import { OrderSummaryProvider } from "~features/checkout/common/components/OrderSummary/context/OrderSummaryContext";
import { useSinglePageCheckoutContext } from "~features/checkout/common/hooks/singlePageCheckoutContext";

export function ExpressCheckoutOrderSummaryProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { order, totals, isQueueProcessing, isQueueSubmitting } =
    useSinglePageCheckoutContext();

  return (
    <OrderSummaryProvider
      allowPromoCode={false}
      isPromoCodeApplied={false}
      order={order}
      totals={totals}
      isLoading={isQueueProcessing}
      isSubmitting={isQueueSubmitting}
    >
      {children}
    </OrderSummaryProvider>
  );
}
